import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { formatMoney } from "../utils/commerce";
import brandConfig from "../config";

const GameCard = ({ game, onPlay, compact = false }) => {
  const { wishlist, toggleWishlist, isUnlocked } = useContext(CartContext);
  const saved = wishlist.includes(game.id);
  const unlocked = isUnlocked(game.id);
  return (
    <article className={`game-card ${compact ? "game-card--compact" : ""}`}>
      <div className="game-card__visual">
        <img src={game.coverImage} alt={`${game.name} gameplay artwork`} loading="lazy" />
        <span className="game-card__category">{game.category}</span>
        {unlocked && <span className="game-card__unlocked">Unlocked</span>}
        <button className={`icon-button game-card__save ${saved ? "is-active" : ""}`} type="button" aria-label={saved ? `Remove ${game.name} from favourites` : `Save ${game.name} to favourites`} aria-pressed={saved} onClick={() => toggleWishlist(game.id)}>{saved ? "♥" : "♡"}</button>
      </div>
      <div className="game-card__body">
        <div><p className="eyebrow">{game.tags.slice(0, 2).join(" · ")}</p><h3><Link to={`/product/${game.id}`}>{game.name}</Link></h3></div>
        <p>{game.shortDescription}</p>
        <div className="game-card__footer">
          <span className="price">{formatMoney(game.price, brandConfig.currency, brandConfig.locale)}</span>
          <div className="game-card__actions"><Link className="button button--quiet button--small" to={`/product/${game.id}`}>Details</Link><button className="button button--small" type="button" onClick={() => onPlay?.(game)}>▶ Try</button></div>
        </div>
      </div>
    </article>
  );
};

export default GameCard;
